import TranslationService from "../services/TranslationService";
import Vue from "vue";
import { mapState } from "vuex";
import { isDefined } from "../helper/utils";
const NotificationService = require("../services/NotificationService");

export default Vue.component("payment-provider-select", {
    props:
    {
        template:
        {
            type: String,
            default: "#vue-payment-provider-select"
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        }
    },


    data()
    {
        return {
            paymentOrder: [6000, 6013, 6094, 6092, 1, 6046, 6128, 6022, 4]
        };
    },

    computed:
        {
            sortedPaymentList()
            {
                return this.methodOfPaymentList.slice().sort((first, second) =>
                {
                    const indexA = this.paymentOrder.indexOf(first.id);
                    const indexB = this.paymentOrder.indexOf(second.id);

                    return (indexA === -1 ? 99 : indexA) - (indexB === -1 ? 99 : indexB);
                });
            },
            invoiceSelectable()
            {
                if (this.billing)
                {
                    if (this.billing?.options?.some(opt => opt.typeId === 9 && opt.value))
                    {
                        return true;
                    }
                }
                return false;
            },
            ...mapState({
                methodOfPaymentList: state => state.checkout.payment.methodOfPaymentList,
                methodOfPaymentId: state => state.checkout.payment.methodOfPaymentId,
                showError: state => state.checkout.validation.paymentProvider.showError,
                isBasketLoading: state => state.basket.isBasketLoading,
                isCheckoutReadonly: state => state.checkout.readOnly,
                selectedShippingProfile: state => state.checkout.shipping.selectedShippingProfile,
                billing: state => state.address.billingAddress
            })
        },

    /**
     * Initialise the event listener
     */
    created()
    {
        this.$store.commit("setPaymentProviderValidator", this.validate);
    },

    methods: {
        /**
         * Event when changing the payment provider
         */
        onPaymentProviderChange(newMethodOfPayment)
        {
            this.$store.dispatch("selectMethodOfPayment", newMethodOfPayment.id)
                .then(data =>
                {
                    document.dispatchEvent(new CustomEvent("afterPaymentMethodChanged", { detail: this.methodOfPaymentId }));
                },
                error =>
                {
                    console.log("error");
                });

            this.validate();
            if (newMethodOfPayment.id == 6092)
            {
                if (!this.billing?.options?.some(opt => opt.typeId === 9 && opt.value))
                {
                    vueEventHub.$emit("changedToInvoice", this.billing);
                    NotificationService.error("Sie müssen für den Rechnungskauf ein Geburtsdatum hinterlegen.");
                }
            }

        },

        validate()
        {
            const showError = !(this.methodOfPaymentId > 0);

            this.$store.commit("setPaymentProviderShowError", showError);

            if (showError)
            {
                NotificationService.error(
                    TranslationService.translate("Ceres::Template.checkoutCheckPaymentProvider")
                );
            }
        },

        isPaymentMethodExcluded(paymentMethodId)
        {
            if (isDefined(this.selectedShippingProfile?.excludedPaymentMethodIds))
            {
                return this.selectedShippingProfile.excludedPaymentMethodIds.includes(paymentMethodId);
            }
            else
            {
                return false;
            }
        }
    }
});
